export * from "./regex";

const regexEmail = (email) => /$^|.+@.+..+/.test(email);

export const notContainsOnlySpaces = (str) => {
  return str.trim().length;
};

const checkPassword = (str) => {
  var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,16}$/;
  return re.test(str);
};

export const validationEmployeeInput = (fieldValues, temp) => {
  if ("firstName" in fieldValues) {
    temp.firstName = notContainsOnlySpaces(fieldValues.firstName)
      ? ""
      : "This field is required.";
  }

  if ("lastName" in fieldValues) {
    temp.lastName = notContainsOnlySpaces(fieldValues.lastName)
      ? ""
      : "This field is required.";
  }

  if ("address" in fieldValues) {
    temp.address = "";
  }

  if ("email" in fieldValues) {
    if (!fieldValues.email) {
      temp.email = "This field is required.";
    } else if (!regexEmail(fieldValues.email)) {
      temp.email = "Email is not valid.";
    } else {
      temp.email = "";
    }
  }

  if ("phone" in fieldValues) {
    if (!fieldValues.phone) {
      temp.phone = "This field is required.";
    } else if (isNaN(fieldValues.phone)) {
      temp.phone = "Number is required.";
    } else if (fieldValues.phone.length < 9) {
      temp.phone = "Minimum 10 numbers required.";
    } else if (fieldValues.phone.length > 11) {
      temp.phone = "Maximum 11 numbers required.";
    } else {
      temp.phone = "";
    }
  }

  if ("salary" in fieldValues) {
    if (!fieldValues.salary) {
      temp.salary = "This field is required.";
    } else if (isNaN(fieldValues.salary)) {
      temp.salary = "Number is required.";
    } else {
      temp.salary = "";
    }
  }

  if ("departmentId" in fieldValues) {
    if (!fieldValues.departmentId.length) {
      temp.departmentId = "This field is required.";
    } else {
      temp.departmentId = "";
      temp.roleId = "";
    }
  }

  if ("roleId" in fieldValues) {
    if (!fieldValues.roleId.length) {
      temp.roleId = "This field is required.";
    } else {
      temp.roleId = "";
    }
  }

  return temp;
};

export const validationPermissionInput = (fieldValues, temp) => {
  if ("name" in fieldValues) {
    temp.name = notContainsOnlySpaces(fieldValues.name)
      ? ""
      : "This field is required.";
  }

  if ("permissionAction" in fieldValues) {
    temp.permissionAction = fieldValues.permissionAction.length
      ? ""
      : "Select at least one";
  }

  return temp;
};

export const validationRoleInput = (fieldValues, temp) => {
  if ("name" in fieldValues) {
    temp.name = notContainsOnlySpaces(fieldValues.name)
      ? ""
      : "This field is required.";
  }

  if ("description" in fieldValues) {
    temp.description = "";
  }

  return temp;
};

export const validationDepartmentInput = (fieldValues, temp) => {
  if ("name" in fieldValues) {
    temp.name = notContainsOnlySpaces(fieldValues.name)
      ? ""
      : "This field is required.";
  }

  if ("description" in fieldValues) {
    temp.description = "";
  }

  return temp;
};

export const validationAccessControlInput = (fieldValues, temp) => {
  if ("name" in fieldValues) {
    temp.name = notContainsOnlySpaces(fieldValues.name)
      ? ""
      : "This field is required.";
  }

  if ("route" in fieldValues) {
    temp.route = notContainsOnlySpaces(fieldValues.route)
      ? ""
      : "This field is required.";
  }

  return temp;
};

export const validationChangePasswordInput = (fieldValues, temp) => {
  if ("password" in fieldValues) {
    if (!notContainsOnlySpaces(fieldValues.password)) {
      temp.password = "This field is required.";
    } else {
      temp.password = "";
    }
  }

  if ("newPassword" in fieldValues) {
    if (!notContainsOnlySpaces(fieldValues.newPassword)) {
      temp.newPassword = "This field is required.";
    } else if (!checkPassword(fieldValues.newPassword)) {
      temp.newPassword = "Password invalid";
    } else {
      temp.newPassword = "";
    }
  }

  if ("confirmPassword" in fieldValues) {
    if (!notContainsOnlySpaces(fieldValues.confirmPassword)) {
      temp.confirmPassword = "This field is required.";
    } else if (!checkPassword(fieldValues.confirmPassword)) {
      temp.confirmPassword = "Password invalid";
    } else {
      temp.confirmPassword = "";
    }
  }

  if ("confirmPassword" in fieldValues && "newPassword" in fieldValues) {
    if (fieldValues.newPassword !== fieldValues.confirmPassword) {
      temp.confirmPassword = "Confirm password not match";
    }
  }

  return temp;
};

export const validationADBProvinceInput = (fieldValues, temp) => {
  if ("provinceName" in fieldValues) {
    temp.provinceName = notContainsOnlySpaces(fieldValues.provinceName)
      ? ""
      : "This field is required.";
  }

  if ("provinceCode" in fieldValues) {
    if (fieldValues.provinceCode === null) {
      temp.provinceCode = "This field is required.";
    } else if (fieldValues.provinceCode === "") {
      temp.provinceCode = "This field is required.";
    } else {
      temp.provinceCode = "";
    }
    if (isNaN(fieldValues.provinceCode)) {
      temp.provinceCode = "field must be a number";
    }
  }

  return temp;
};

export const validationADBWardInput = (fieldValues, temp) => {
  if ("wardName" in fieldValues) {
    temp.wardName = notContainsOnlySpaces(fieldValues.wardName)
      ? ""
      : "This field is required.";
  }

  if ("wardCode" in fieldValues) {
    if (fieldValues.wardCode === null) {
      temp.wardCode = "This field is required.";
    } else if (fieldValues.wardCode === "") {
      temp.wardCode = "This field is required.";
    } else {
      temp.wardCode = "";
    }
    if (isNaN(fieldValues.wardCode)) {
      temp.wardCode = "field must be a number";
    }

    if ("districtId" in fieldValues) {
      temp.districtId =
        fieldValues.districtId.length !== 0 ? "" : "This field is required.";
    }
  }

  return temp;
};

export const checkEqual = (state, stateChange) => {
  const keysToCopy = Object.keys(state);

  for (const key of keysToCopy) {
    if (typeof state[key] === "object" && Array.isArray(state[key])) {
      if (!compareTwoArray(state[key], stateChange[key])) {
        return false;
      }
    } else if (state[key] !== stateChange[key]) {
      return false;
    }
  }

  return true;
};

const compareTwoArray = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false;
  }

  const values = new Set(arr1);

  for (let i = 0; i < arr2.length; i++) {
    const value = arr2[i];
    if (!values.has(value)) {
      return false;
    }
  }

  return true;
};

export const refusedToUpdate = (id, statusEdited) => {
  if (id && statusEdited) {
    return true;
  }
  return false;
};

export const isDisableSubmit = (state, statechange) => {
  if (state) {
    return refusedToUpdate(state?.id, checkEqual(state, statechange));
  } else {
    if (statechange?.name) {
      return !notContainsOnlySpaces(statechange?.name);
    }
    if (statechange?.partnerName) {
      return !notContainsOnlySpaces(statechange?.partnerName);
    }
  }
};
